import type { GalleryRepository } from '../domain/repositories/GalleryRepository.interface';
import { Album } from '../domain/entities/Album.entity';
import { GalleryItem } from '../domain/entities/GalleryItem.entity';
import { albumsContent, galleryItemsContent } from '../content/gallery.content';

export class StaticGallerySource implements GalleryRepository {
  public async getAlbums(): Promise<Album[]> {
    return albumsContent.map((input) => Album.create(input));
  }

  public async getAllItems(): Promise<GalleryItem[]> {
    return galleryItemsContent.map((input) => GalleryItem.create(input));
  }

  public async getItemsByAlbum(albumId: string): Promise<GalleryItem[]> {
    return galleryItemsContent
      .filter((input) => input.albumId === albumId)
      .map((input) => GalleryItem.create(input));
  }

  public async getItemsByProject(projectId: string): Promise<GalleryItem[]> {
    return galleryItemsContent
      .filter((input) => input.projectId === projectId)
      .map((input) => GalleryItem.create(input));
  }
}
